import axios from "axios";
import getCatalogosApiService from "./CatalogosApiService.js";

export default class EmpleadosServicio {
  // URL_SERVIDOR_LOGIN =
  //   process.env.VUE_APP_API_URL + "/administracion/beta/Admin/";
  URL_SERVIDOR_LOGIN =
    process.env.VUE_APP_API_URL + "/administracion/v1/empleado/";

  // Cambiar para usar el endpoint que ya tiene la lógica de consecutivos implementada
  URL_SERVIDOR = process.env.VUE_APP_API_URL + "/administracion/v1/beta/empleados/";
  URL_INFOMAP = process.env.VUE_APP_API_URL + "/administracion/v1/beta/InfoMap/";
  datos = [];
  catalogosApiService = getCatalogosApiService();

  // Removed class-level request tracking variables

  async saveInfo(empleados) {
    try {
      const response = await axios.post(this.URL_SERVIDOR + "save", empleados);
      return response;
    } catch (error) {

      throw error;
    }
  }

  async todos() {
    try {
      const response = await axios.get(this.URL_SERVIDOR + "todos");
      return response;
    } catch (error) {

      throw error;
    }
  }

  async getAll() {
    try {
      const response = await axios.get(this.URL_INFOMAP + "todos");
      return response;
    } catch (error) {

      throw error;
    }
  }

  async getInfoMapByEmpId(empId) {
    try {
      const response = await axios.get(this.URL_INFOMAP + empId);
      return response;
    } catch (error) {

      throw error;
    }
  }

  async getEmpleadoDetalleByEmpId(empId) {
    try {
      const response = await axios.get(process.env.VUE_APP_API_URL + "/administracion/v1/empleadoDetalle/" + empId);
      return response;
    } catch (error) {

      throw error;
    }
  }

  /**
   * Obtener el proveedor asociado a un empleado por su número de empleado
   * @param {string} empId - Número de empleado
   * @returns {Promise} Proveedor asociado al empleado
   */
  async getProveedorByEmpId(empId) {
    try {
      const response = await axios.get(
        process.env.VUE_APP_API_URL + "/administracion/v1/beta/empleados/proveedor/" + empId
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null; // Retornar null en lugar de lanzar error
      }
      throw error;
    }
  }

  async getEmpId(empId) {
    try {
      const response = await axios.get(this.URL_SERVIDOR + "empId/" + empId);
      return response;
    } catch (error) {

      throw error;
    }
  }

  async getPuesto(puesto) {
    try {
      const response = await axios.get(this.URL_INFOMAP + "reporte/" + puesto);
      return response;
    } catch (error) {

      throw error;
    }
  }

  async save(empleado) {
    try {
      const response = await axios.post(this.URL_SERVIDOR + "save", empleado);
      return response;
    } catch (error) {

      throw error;
    }
  }

  async edit(empleado) {
    try {
      const response = await axios.post(this.URL_SERVIDOR + "edit", empleado);
      return response;
    } catch (error) {

      throw error;
    }
  }

  /**
   * Sube un archivo (documento) al servidor
   * @param {FormData} formData - FormData con el archivo a subir
   * @returns {Promise} Respuesta del servidor con la URL del archivo subido
   */
  async upload(formData) {
    try {
      // Usar el endpoint de empleadosInfoAdicional para subir documentos
      // que es el que está disponible y funcionando
      const uploadUrl = process.env.VUE_APP_API_URL + "/administracion/v1/beta/empleadosInfoAdicional/upload/doc";
      
      const response = await axios.post(uploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Método de prueba para verificar conectividad
  async testEndpoint(empId = "BMEXM0233") {
    try {
      const testUrl = process.env.VUE_APP_API_URL + "/administracion/v1/empleado/numeroEmpleado/" + empId;

      const response = await axios.get(testUrl);

      return response;
    } catch (error) {

      throw error;
    }
  }

  async login(username, password) {
    try {
      const loginUrl = this.URL_SERVIDOR_LOGIN + "login";
      const loginData = {
        empId: username,
        password: password,
      };

      // Probar conectividad primero

      try {
        await this.testEndpoint(username);

      } catch (testError) {

        // Continuar con login de todas formas
      }
      
      const response = await axios.post(loginUrl, loginData);

      return response;
    } catch (error) {

      throw error;
    }
  }

  async findTienda(tienda) {
    try {
      const response = await this.catalogosApiService.getTiendaById(tienda);
      return { data: response };
    } catch (error) {

      throw error;
    }
  }

  async getAllProveedores() {
    try {
      // Usar el nuevo servicio de proveedores
      const response = await axios.get(process.env.VUE_APP_API_URL + "/administracion/v1/proveedores/activos");
      return { data: response.data };
    } catch (error) {

      // Datos mock temporales para que la interfaz funcione
      const mockProveedores = [
        { id: 1, nombreComercial: "BETA EXPRESS", rfc: "BETA123456789", email: "admin@betaexpress.com" },
        { id: 2, nombreComercial: "TRANSPORTES MEXICANOS", rfc: "TRA987654321", email: "contacto@transmex.com" },
        { id: 3, nombreComercial: "LOGÍSTICA INTEGRAL", rfc: "LOG456789123", email: "info@logisticaintegral.com" }
      ];
      return { data: mockProveedores };
    }
  }

  async getAllTiendas() {
    try {
      const response = await this.catalogosApiService.getAllTiendas();
      return { data: response };
    } catch (error) {

      // Datos mock temporales para que la interfaz funcione
      const mockTiendas = [
        { id: 1, nomenclatura: "T001", nombre: "Tienda Centro", ubicacion: "Centro" },
        { id: 2, nomenclatura: "T002", nombre: "Tienda Norte", ubicacion: "Norte" },
        { id: 3, nomenclatura: "T003", nombre: "Tienda Sur", ubicacion: "Sur" }
      ];
      return { data: mockTiendas };
    }
  }

  async getTabulador() {
    try {
      // Usar getAllTabuladoresActivos para obtener solo los tabuladores activos
      const response = await this.catalogosApiService.getAllTabuladoresActivos();
      return { data: response };
    } catch (error) {

      // Datos mock temporales
      const mockTabuladores = [
        { id: 1, descripcion: "Tabulador A", monto: 15000 },
        { id: 2, descripcion: "Tabulador B", monto: 20000 },
        { id: 3, descripcion: "Tabulador C", monto: 25000 }
      ];
      return { data: mockTabuladores };
    }
  }

  async getEsquemaFiltrar(tipo) {
    try {
      // Usar getAllEsquemasActivos para obtener solo los esquemas activos
      const allEsquemas = await this.catalogosApiService.getAllEsquemasActivos();
      // Filtrar esquemas por tipo si se especifica
      const filteredEsquemas = tipo ? allEsquemas.filter(esquema => esquema.tipoEsquema === tipo) : allEsquemas;
      return { data: filteredEsquemas };
    } catch (error) {

      // Datos mock temporales con estructura correcta basada en esquemaUnidad
      const mockEsquemas = [
        { id: 31, tipoEsquema: "A", descripcion: "EMPRESA", nombre: "EMPRESA" },
        { id: 32, tipoEsquema: "A", descripcion: "CONSIGNA", nombre: "CONSIGNA" },
        { id: 34, tipoEsquema: "A", descripcion: "CONSIGNA BETA", nombre: "CONSIGNA BETA" },
        { id: 35, tipoEsquema: "B", descripcion: "RENTA", nombre: "RENTA" },
        { id: 36, tipoEsquema: "B", descripcion: "RENTALS", nombre: "RENTALS" },
        { id: 37, tipoEsquema: "B", descripcion: "ALQUILADAS", nombre: "ALQUILADAS" }
      ];
      const filteredEsquemas = tipo ? mockEsquemas.filter(esquema => esquema.tipoEsquema === tipo) : mockEsquemas;
      return { data: filteredEsquemas };
    }
  }

  async getCpFiltrar(cp) {
    try {
      // Usar el CatalogosApiService para mantener consistencia con el patrón de refactorización
      const response = await this.catalogosApiService.getColoniasPorCodigoPostal(cp.cp);
      return { data: response };
    } catch (error) {

      throw error;
    }
  }

  async getEstados() {
    try {
      // Usar getAllEstadosActivos para obtener solo los estados activos
      const response = await this.catalogosApiService.getAllEstadosActivos();
      // Mapear los datos de la entidad para que coincidan con la estructura esperada
      const mappedEstados = response.map(estadoItem => ({
        id: estadoItem.id,
        lugarNacimiento: estadoItem.estado,
        estado: estadoItem.estado,
        claveCurp: estadoItem.claveCurp
      }));
      return { data: mappedEstados };
    } catch (error) {

      // Datos mock temporales que coinciden con la estructura mapeada
      const mockEstados = [
        { id: 1, estado: "Aguascalientes", lugarNacimiento: "Aguascalientes", claveCurp: "AS" },
        { id: 2, estado: "Baja California", lugarNacimiento: "Baja California", claveCurp: "BC" },
        { id: 3, estado: "Baja California Sur", lugarNacimiento: "Baja California Sur", claveCurp: "BS" },
        { id: 4, estado: "Campeche", lugarNacimiento: "Campeche", claveCurp: "CC" },
        { id: 5, estado: "Coahuila", lugarNacimiento: "Coahuila", claveCurp: "CL" }
      ];
      return { data: mockEstados };
    }
  }

  async getBancos(numeroClaveBanco) {
    try {
      const response = await this.catalogosApiService.getBancoById(numeroClaveBanco);
      return { data: response };
    } catch (error) {
      throw error;
    }
  }

  async getNum(nomEmp) {
    try {
      const response = await axios.post(this.URL_SERVIDOR + "count", nomEmp);
      return response;
    } catch (error) {

      throw error;
    }
  }

  async saveEmpTiendas(empleadosTiendas) {
    try {
      const response = await axios.post(
        this.URL_SERVIDOR + "empleadosTiendas",
        empleadosTiendas
      );
      return response;
    } catch (error) {

      throw error;
    }
  }

  async getAreas() {
    try {
      const response = await this.catalogosApiService.getAllAreasActivas();
      // Mapear los datos del DTO para que coincidan con la estructura esperada
      const mappedAreas = response.map(area => ({
        id: area.id,
        tipoArea: area.nombre,
        nombre: area.nombre
      }));
      return { data: mappedAreas };
    } catch (error) {

      // Datos mock temporales que coinciden con la estructura mapeada
      const mockAreas = [
        { id: 1, tipoArea: "Ventas", nombre: "Área de Ventas" },
        { id: 2, tipoArea: "Administración", nombre: "Área de Administración" },
        { id: 3, tipoArea: "Operaciones", nombre: "Área de Operaciones" }
      ];
      return { data: mockAreas };
    }
  }

  async getPuestos() {
    try {
      const response = await this.catalogosApiService.getAllPuestosActivos();
      // Mapear los datos de la entidad para que coincidan con la estructura esperada
      const mappedPuestos = response.map(puestoItem => ({
        id: puestoItem.id,
        tipoPuesto: puestoItem.puesto,
        nombre: puestoItem.puesto
      }));
      return { data: mappedPuestos };
    } catch (error) {

      // Datos mock temporales que coinciden con la estructura mapeada
      const mockPuestos = [
        { id: 1, tipoPuesto: "Vendedor", nombre: "Vendedor" },
        { id: 2, tipoPuesto: "Supervisor", nombre: "Supervisor" },
        { id: 3, tipoPuesto: "Gerente", nombre: "Gerente" }
      ];
      return { data: mockPuestos };
    }
  }

  async getDepartamentos() {
    try {
      const response = await this.catalogosApiService.getAllDepartamentosActivos();
      // Mapear los datos de la entidad para que coincidan con la estructura esperada
      const mappedDepartamentos = response.map(departamentoItem => ({
        id: departamentoItem.id,
        tipoDepartamento: departamentoItem.departamento,
        nombre: departamentoItem.departamento
      }));
      return { data: mappedDepartamentos };
    } catch (error) {

      // Datos mock temporales que coinciden con la estructura mapeada
      const mockDepartamentos = [
        { id: 1, tipoDepartamento: "Recursos Humanos", nombre: "Recursos Humanos" },
        { id: 2, tipoDepartamento: "Finanzas", nombre: "Finanzas" },
        { id: 3, tipoDepartamento: "Tecnología", nombre: "Tecnología" }
      ];
      return { data: mockDepartamentos };
    }
  }

  async getMarcas() {
    try {
      // Las marcas ahora están integradas en UnidadFlota, no como catálogo independiente
      // Devolvemos array vacío por compatibilidad

      return { data: [] };
    } catch (error) {

      throw error;
    }
  }

  async getSubMarcas() {
    try {
      // Las submarcas ahora están integradas en UnidadFlota, no como catálogo independiente
      // Devolvemos array vacío por compatibilidad

      return { data: [] };
    } catch (error) {

      throw error;
    }
  }

  async getReporte() {
    try {
      const response = await axios.get(this.URL_SERVIDOR + "reporte");
      return response;
    } catch (error) {

      throw error;
    }
  }

  async getViewEmpleados() {
    try {
      const response = await axios.get(this.URL_SERVIDOR + "empleadosActivos/1");
      return response;
    } catch (error) {

      throw error;
    }
  }

  // getViewEmpleados(page = 0, size = 10) {
  //     return axios.get(this.URL_SERVIDOR + "empleadosActivos")
  //             .then(response => {

  //                 return response;
  //             })
  //             .catch(error => {
  //
  //                 throw error;
  //             });
  // }

  async getViewEmpleados(
    filter = "A",
    page = 0,
    size = 10,
    columnFilters = null
  ) {
    try {
      // Add timestamp to URL to prevent caching
      const timestamp = new Date().getTime();

      // Verificar si filter es un objeto y procesarlo correctamente
      let filterValue = filter;
      if (typeof filter === "object" && filter !== null) {
        filterValue = "A"; // Valor por defecto si se pasa un objeto
      }

      // Construir URL base con parámetros de paginación
      let url = `${this.URL_SERVIDOR}empleadosActivos/${filterValue}?page=${page}&size=${size}&_t=${timestamp}`;

      // Agregar parámetros de filtro de columnas si existen
      if (columnFilters && Object.keys(columnFilters).length > 0) {
        // Usar el endpoint de filtros avanzados si hay filtros de columna
        url = `${this.URL_SERVIDOR}empleadosFiltrados/${filterValue}?page=${page}&size=${size}&_t=${timestamp}`;
        
        // Agregar filtros como parámetros de consulta
        Object.keys(columnFilters).forEach((key) => {
          if (
            columnFilters[key] &&
            columnFilters[key].trim !== undefined &&
            columnFilters[key].trim() !== ""
          ) {
            url += `&${key}=${encodeURIComponent(columnFilters[key])}`;
          }
        });
      }

      const response = await axios.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Nuevo método específico para exportación que devuelve todos los registros
  async getViewEmpleadosExport(filter = "A", columnFilters = null) {
    try {
      // Add timestamp to URL to prevent caching
      const timestamp = new Date().getTime();

      // Verificar si filter es un objeto y procesarlo correctamente
      let filterValue = filter;
      if (typeof filter === "object" && filter !== null) {
        filterValue = "A"; // Valor por defecto si se pasa un objeto
      }

      // Para exportación, usar el endpoint con tamaño grande para obtener todos los registros
      // Usar size=100000 para asegurar que obtenemos todos los registros de la BD
      let url = `${this.URL_SERVIDOR}empleadosActivos/${filterValue}?page=0&size=100000&_t=${timestamp}`;

      // Agregar parámetros de filtro de columnas si existen
      if (columnFilters && Object.keys(columnFilters).length > 0) {
        // Usar el endpoint de filtros avanzados si hay filtros de columna
        url = `${this.URL_SERVIDOR}empleadosFiltrados/${filterValue}?page=0&size=100000&_t=${timestamp}`;
        
        // Agregar filtros como parámetros de consulta
        Object.keys(columnFilters).forEach((key) => {
          if (
            columnFilters[key] &&
            columnFilters[key].trim !== undefined &&
            columnFilters[key].trim() !== ""
          ) {
            url += `&${key}=${encodeURIComponent(columnFilters[key])}`;
          }
        });
      }

      const response = await axios.get(url);
      return response;
    } catch (error) {

      throw error;
    }
  }

  // Nuevo método para obtener empleados con filtros avanzados usando el nuevo endpoint
  async getEmpleadosConFiltrosAvanzados(
    filter = "A",
    page = 0,
    size = 10,
    columnFilters = null
  ) {
    try {
      // Add timestamp to URL to prevent caching
      const timestamp = new Date().getTime();

      // Construir URL base con parámetros de paginación
      let url = `${this.URL_SERVIDOR}empleadosFiltrados/${filter}?page=${page}&size=${size}&_t=${timestamp}`;

      // Agregar filtros como parámetros de consulta
      if (columnFilters && Object.keys(columnFilters).length > 0) {
        Object.keys(columnFilters).forEach((key) => {
          if (
            columnFilters[key] &&
            columnFilters[key].trim !== undefined &&
            columnFilters[key].trim() !== ""
          ) {
            url += `&${key}=${encodeURIComponent(columnFilters[key])}`;
          }
        });
      }

      const response = await axios.get(url);
      return response;
    } catch (error) {

      throw error;
    }
  }

  // Método para obtener todos los empleados activos sin paginación
  async getAllEmpleadosActivos() {
    try {
      const timestamp = new Date().getTime();
      // Usar size=100000 para obtener todos los registros de la BD
      const url = `${this.URL_SERVIDOR}empleadosActivos/1?page=0&size=100000&_t=${timestamp}`;
      
      const response = await axios.get(url);
      return response;
    } catch (error) {

      throw error;
    }
  }

  /**
   * Obtiene información completa de dirección por ID de colonia
   * @param {number} idColonia - ID de la colonia
   * @returns {Promise<Object>} Información completa de dirección
   */
  async getDireccionCompletaPorColonia(idColonia) {
    try {
      const url = `${this.URL_SERVIDOR_LOGIN.replace('/empleado/', '/empleadoDetalle/')}direccion-completa/${idColonia}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Guarda la cuenta bancaria de un empleado
   * @param {Object} cuentaBancariaData - Datos de la cuenta bancaria
   * @param {number} cuentaBancariaData.fkEmpleado - ID del empleado
   * @param {number} cuentaBancariaData.fkBanco - ID del banco
   * @param {string} cuentaBancariaData.cuentaBancaria - Número de cuenta bancaria
   * @returns {Promise<Object>} Respuesta del servidor
   */
  async saveEmpleadoCuentaBancaria(cuentaBancariaData) {
    try {
      // Usar la misma estructura que CatalogosApiService: /catalogos/v1/api
      // El controlador tiene @RequestMapping("/api/empleado-cuenta-bancaria")
      // Entonces la URL completa es: /catalogos/v1/api/empleado-cuenta-bancaria
      const url = process.env.VUE_APP_API_URL + "/catalogos/v1/api/empleado-cuenta-bancaria";
      const response = await axios.post(url, cuentaBancariaData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Actualiza la cuenta bancaria de un empleado
   * @param {number} id - ID de la cuenta bancaria
   * @param {Object} cuentaBancariaData - Datos de la cuenta bancaria actualizada
   * @returns {Promise<Object>} Respuesta del servidor
   */
  async updateEmpleadoCuentaBancaria(id, cuentaBancariaData) {
    try {
      const url = process.env.VUE_APP_API_URL + "/catalogos/v1/api/empleado-cuenta-bancaria/" + id;
      const response = await axios.put(url, cuentaBancariaData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Obtiene el ID del empleado por su número de empleado (empId)
   * @param {string} empId - Número de empleado
   * @returns {Promise<number>} ID del empleado
   */
  async getEmpleadoIdByEmpId(empId) {
    try {
      const url = process.env.VUE_APP_API_URL + "/administracion/v1/empleado/numeroEmpleado/" + empId;
      const response = await axios.get(url);
      // El ID debería estar en response.data.id
      return response.data?.id || null;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Obtiene la cuenta bancaria de un empleado por su ID
   * @param {number} empleadoId - ID del empleado
   * @returns {Promise<Object|null>} Datos de la cuenta bancaria o null si no existe
   */
  async getEmpleadoCuentaBancariaByEmpleadoId(empleadoId) {
    try {
      const url = process.env.VUE_APP_API_URL + "/catalogos/v1/api/empleado-cuenta-bancaria/empleado/" + empleadoId;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      // Si es 404, no hay cuenta bancaria, retornar null
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }
}
